import { render } from "./App.vue?vue&type=template&id=afec840c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=afec840c&lang=css"

import exportComponent from "E:\\backup\\Vue\\NK\\Add_line\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__